import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'social-media-emotionen-einleitung',
  title: 'Social Media & Emotionen: Die unterschätzte Gefahr für deine Finanzentscheidungen',
  content: `
    <p>
      In der heutigen digitalen Welt sind wir ständig von Informationen umgeben. Besonders in sozialen Medien werden wir täglich mit Finanzinhalten überflutet – von Investmenttipps über Aktienempfehlungen bis hin zu vermeintlichen Erfolgsgeschichten. Doch was viele unterschätzen: Diese Inhalte sprechen oft gezielt unsere Emotionen an und beeinflussen damit unsere Entscheidungsfähigkeit.
    </p>
    
    <p>
      Als Finanzcoach beobachte ich mit Sorge, wie emotionale Manipulation in sozialen Medien finanzielle Fehlentscheidungen begünstigt. In diesem Artikel möchte ich dir zeigen, wie Emotionen in Social Media deine Finanzentscheidungen beeinflussen und wie du dich davor schützen kannst.
    </p>
  `
};
